module.exports = __webpack_public_path__ + "img/thumbnail-grid-calyrafit.4a45ea54.webp";